import gql from 'graphql-tag';

export const GET_OFFER = gql`
  query GetOffer($params: OfferGetByUuidInput!) {
    offerGetByUuid(params: $params) {
      offerUuid
      offerDescription
      offerName
      offerKeywords
      offerStartDate
      offerEndDate
      paymentNetworkMCC
      paymentNetworkMCCDescription
      exactSpendToActivate
      minimumSpendToActivate
      segments {
        uuid
        cashbackAmount
        cashbackDailyLimit
        cashbackPercentage
        segmentType
        segmentPriority
        startDate
        endDate
        offerTitleOverride
        hideOfferForSegment
        minSpendToActivate
        exactSpendToActivate
        baseCashbackAmount
        baseCashbackPercentage
        promotionType
        financialTerm {
          financialTermItems {
            budgetId
            termType
            payerType
            termValue
            termUnits
            termUnitsScaleFactor
            campaignId
            insertionOrderTicket
          }
        }
        targetingRules {
          type
          data
          dataByKey
        }
        marketplaces
        throttle {
          uuid
          min
          max
          name
          description
          adjustmentTicketUrl
          adjustmentUpdatedBy
          governorRanges {
            includeRange {
              min
              max
            }
            includeRangeEnabled
            excludeRange {
              min
              max
            }
            excludeRangeEnabled
          }
        }
        audience {
          audienceUuid
          externalId
          name
          status
          effectiveAt
        }
      }
    }
  }
`;

export const GET_CAMPAIGN_BY_UUID = gql`
  query GetCampaignByUuid($params: CampaignUuidInput!) {
    campaignByUuid(params: $params) {
      insertionOrder {
        ticket
      }
    }
  }
`;

export const CREATE_TEMPORARY_OFFER_SEGMENT = gql`
  mutation($params: TemporaryOfferSegmentInput!) {
    pulseOfferSegment(params: $params) {
      merchantName
      merchantUuid
      offerUuid
      segments {
        uuid
        cashbackAmount
        cashbackDailyLimit
        cashbackPercentage
        baseCashbackAmount
        baseCashbackPercentage
        promotionType
        updatedBy
      }
    }
  }
`;

export const REPLACE_OFFER_SEGMENT = gql`
  mutation($params: ReplaceOfferSegmentInput!) {
    replaceOfferSegment(params: $params) {
      merchantName
      merchantUuid
      offerUuid
      segments {
        uuid
        cashbackAmount
        cashbackDailyLimit
        cashbackPercentage
        baseCashbackAmount
        baseCashbackPercentage
        promotionType
        updatedBy
      }
    }
  }
`;

export const ADD_OFFER_SEGMENT = gql`
  mutation($params: CreateOfferSegmentInput!) {
    createOfferSegment(params: $params) {
      merchantName
      merchantUuid
      offerUuid
      segments {
        uuid
        cashbackAmount
        cashbackDailyLimit
        cashbackPercentage
        baseCashbackAmount
        baseCashbackPercentage
        promotionType
        updatedBy
        endDate
        startDate
        financialTerm {
          financialTermItems {
            budgetId
            termType
            payerType
            termValue
            termUnits
            termUnitsScaleFactor
            campaignId
            insertionOrderTicket
          }
        }
        targetingRules {
          type
          data
          dataByKey
        }
        marketplaces
        throttle {
          uuid
          min
          max
          name
          description
          governorRanges {
            includeRange {
              min
              max
            }
            includeRangeEnabled
            excludeRange {
              min
              max
            }
            excludeRangeEnabled
          }
        }
      }
    }
  }
`;

export default GET_OFFER;
